import { render, staticRenderFns } from "./modalConfirmarLiquidacion.vue?vue&type=template&id=6c862e6e&"
import script from "./modalConfirmarLiquidacion.vue?vue&type=script&lang=js&"
export * from "./modalConfirmarLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports